module.exports = __webpack_public_path__ + "static/yum_body_img2-ec967c25cbf9348a0a3fd4d8c5d3f790.png";